import { Container } from '@mui/material';
import React from 'react';

const NotFound = () => {
    return (
        <Container style={{paddingTop: '100px'}}>
       <img src="https://i.ibb.co/6yhDP29/404-error-page-not-found-Oops-connection-is-lost-Use-for-landing-page-template-web-app-poster-banner.jpg" alt="" />

    </Container>
    );
};

export default NotFound;